import { createActionGroup, props } from '@ngrx/store'
import { CreditTowerControls } from '../../model/credit-tower.model'

export const CreditTowerActions = createActionGroup({
  source: 'Credit Tower',
  events: {
    'Update Controls': props<{ towerControls: CreditTowerControls }>(),
  },
})
